export * from "./types";
import slice from "./slice";
export const { resetCreatePatientBrandPrescriberInfoAsyncAction, resetUpdatePatientBrandPrescriberInfoAsyncAction } = slice.actions;
